module.exports = __webpack_public_path__ + "img/img_half_futanoura_2.3b021a0c.png";